<div class="banner d-none d-lg-flex" role="banner">
  <h1>{{ 'challenges.page.title' | translate }}</h1>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>
<div
  [ngClass]="{
    'kid-achieved': isKid
  }"
>
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="mt-4">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
